package nl.astraeus.wiki

import kotlinx.browser.document
import nl.astraeus.komp.Komponent
import nl.astraeus.wiki.domain.Page
import nl.astraeus.wiki.domain.WikiListDto
import nl.astraeus.wiki.domain.WikiPageDto
import nl.astraeus.wiki.encoding.Tokenizer
import nl.astraeus.wiki.messages.*
import nl.astraeus.wiki.service.UserService
import nl.astraeus.wiki.view.ConfirmModal
import nl.astraeus.wiki.ws.sendMessage
import nl.astraeus.wiki.ws.sendMessageWithSpinner

object WikiData {
  val wikiList = mutableListOf<WikiListDto>()
  val pageList = mutableListOf<WikiPageDto>()
  var currentWiki: WikiListDto? = null
  var currentPage: Page? = null

  fun clear() {
    wikiList.clear()
    pageList.clear()
    currentWiki = null
    currentPage = null
  }

  fun loadWiki(id: Long) {
    sendMessageWithSpinner(GetWikiMessage(id)) { msg ->
      check(msg.getMessageType() == MessageType.WIKI_MESSAGE)

      val wikiMessage = WikiMessage(msg.message)

      currentWiki = WikiListDto(
        wikiMessage.getHeader(MessageHeader.WIKI_ID).toLong(),
        wikiMessage.getHeader(MessageHeader.WIKI_ID),
        UserService.currentUser?.id ?: 0L,
        wikiMessage.getHeader(MessageHeader.WIKI_TITLE),
        0,
        ""
      )
      currentPage = null
      pageList.clear()
      for (line in wikiMessage.getBody().trim().lines()) {
        if (line.isNotBlank()) {
          pageList.add(WikiPageDto(Tokenizer(line)))
        }
      }
      if (pageList.isNotEmpty()) {
        loadPage(pageList[0].id)
      }

      mainView.requestUpdate()
    }
  }

  fun addPage() {
    val wiki = currentWiki ?: error("No wiki selected")

    sendMessageWithSpinner(CreatePageMessage(wiki.id)) { msg ->
      val pageMessage = PageMessage(msg.message)

      pageList.add(
        WikiPageDto(
          pageMessage.getHeader(MessageHeader.PAGE_ID).toLong(),
          pageMessage.getHeader(MessageHeader.WIKI_ID),
          0L,
          pageMessage.getHeader(MessageHeader.PAGE_TITLE),
        )
      )

      updatePage(msg)

      mainView.requestUpdate()
    }
  }

  fun loadPage(id: Long) {
    sendMessage(GetPageMessage(id)) { msg ->
      updatePage(msg)

      mainView.requestUpdate()
    }
  }

  private fun updatePage(msg: Message) {
    check(msg.getMessageType() == MessageType.PAGE_MESSAGE)

    val pageMessage = PageMessage(msg.message)

    currentPage = Page(
      pageMessage.getHeader(MessageHeader.PAGE_ID).toLong(),
      pageMessage.getHeader(MessageHeader.WIKI_ID).toLong(),
      null,
      pageMessage.getHeader(MessageHeader.PAGE_TITLE),
      pageMessage.getBody()
    )
  }

  fun removePage(id: Long, title: String) {
    Komponent.create(document.body!!,
      ConfirmModal("Remove page", "Are you sure you want to remove the page '$title'?") {
        sendMessageWithSpinner(RemovePageMessage(id)) { msg ->
          if (msg.getMessageType() == MessageType.SUCCESS) {
            pageList.filter { it.id == id }.forEach { pageList.remove(it) }

            mainView.requestUpdate()
          } else {
            TODO("Notify not implemented!")
          }
        }
      })
  }

  fun removeWiki(id: Long, title: String) {
    Komponent.create(
      document.body!!,
      ConfirmModal(
        "Remove wiki",
        "Are you sure you want to remove the wiki '$title'?",
      ) {
        sendMessageWithSpinner(RemoveWikiMessage(id)) { msg ->
          if (msg.getMessageType() == MessageType.SUCCESS) {
            val idx = wikiList.indexOfFirst { it.id == id }
            if (idx >= 0) {
              wikiList.removeAt(idx)
            }
            mainView.requestUpdate()
          } else {
            console.error("Failed to remove wiki", msg)
          }
        }
      }
    )
  }
}
